CustomTC.define('modules/thumbs/thumbs',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/load-data', 'modules/language', 'modules/chat/chat', 'modules/logger', 'text!modules/htmls/loading.html', 'text!modules/thumbs/htmls/thumbs.html', 'css!modules/css/loading', 'css!modules/thumbs/css/thumbs'], function(util, core, config, constants, options, loadData, language, chat, logger, loading, thumbs) {
    return {
        colorArr: [],
        //init
        init: function(playerUI, video) {
            this.playerUI = playerUI;
            this.initializeThumbs();
        },
        initializeThumbs: function() {
            var self = this;
            this.video = options.videoInfo[0];
            // append thumbs container
            var thumbsContainer = core.init(thumbs);
            // core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(thumbsContainer);
            core.init('.tcThumbs').append(thumbsContainer);
            //post thumb
            var thumbsPostIcon = core.init('.' + constants.CSS_TOUCHCAST_THUMBS_ICON + '');
            core.off(thumbsPostIcon, 'touchstart click');
            core.on(thumbsPostIcon, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                self.postThumbs();
                return false;
            });
        },
        receiveThumbs: function(data) {
            logger.log('Received a Like');
            var self = this;
            if (chat.colorArr[data.huuid]) {
                var color = chat.colorArr[data.huuid];
            } else {
                var color = chat.randomColor('hex');
                chat.colorArr[data.huuid] = color;
            }
            if (options.getEnableDisableThumbsSound()) {
                var thumbsAudio = new Audio(options.getThumbSound());
                thumbsAudio.play();
            }
            var thumbsWrapper = core.init('.' + constants.CSS_TOUCHCAST_THUMBS_WRAPPER + '');
            var newThumb = core.init('<i class="thumb icon-thumbs-up-alt" style="color:' + color + '"></i>');
            core.append(thumbsWrapper, newThumb);
        },
        postThumbs: function() {
            var self = this;
            logger.log('Liked');
            var myThumbData = {};
            myThumbData.huuid = chat.huuid;
            self.receiveThumbs(myThumbData);
            var vPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
            var timeChat = vPlayer.currentTime;
            interactiveLayerConfig.livestream_handler.sendLike(timeChat, function(data) {
                logger.log('Data received on posting Like -', data);
            });
        }

    };
});

